import { Box, Typography, Modal, ModalDialog, ModalClose } from '@mui/joy';

export interface CrewModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  innerClass?: string;
  position?: 'center' | 'bottom-right';
}

const CrewModal = ({ open, onClose, title, children, innerClass = '', position = 'center' }: CrewModalProps) => {
  const modalSx =
    position === 'bottom-right'
      ? {
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          padding: '8px'
        }
      : {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={modalSx}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'none',
            backgroundColor: 'transparent'
          }
        }
      }}
    >
      <ModalDialog
        className={innerClass}
        sx={{
          minWidth: 300,
          bgcolor: 'background.level1',
          px: 2,
          py: 1.5,
          borderRadius: 'md',
          borderColor: 'transparent',
          boxShadow: 'lg',
          ...(position === 'bottom-right' && {
            margin: 0,
            position: 'absolute',
            bottom: '8px',
            top: 'auto',
            left: '430px',
            transform: 'none'
          })
        }}
      >
        <Box className={`flex flex-row items-center ${title ? 'justify-between' : 'justify-end'} mb-2`}>
          {title && (
            <Typography
              level='title-md'
              sx={{
                color: 'text.primary'
              }}
            >
              {title}
            </Typography>
          )}
          <ModalClose
            variant='plain'
            sx={{
              position: 'relative',
              top: 'unset',
              right: 'unset',
              bgcolor: 'transparent',
              color: 'neutral.400',
              '&:hover': {
                bgcolor: 'neutral.800',
                color: 'neutral.400'
              },
              borderRadius: 'md',
              p: 0.5
            }}
          />
        </Box>
        {children}
      </ModalDialog>
    </Modal>
  );
};

export default CrewModal;
